@if (isInit) {
  <div class="sc-dialog-wrapper" style="max-width: 768px">
    @if (isQuestionCorrect === undefined) {
      <button
        mat-icon-button
        class="m3-dialog-close-button"
        (click)="abort()"
        [matTooltip]="'close' | translate"
        aria-label="close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    <div class="m3-dialog-header">
      <mat-icon class="m3-dialog-icon">psychology_alt</mat-icon>
      <h2 class="m3-dialog-headline">{{ 'video_question' | translate }}</h2>
      <p
        class="m3-dialog-supporting-text mb-0 px-4"
        [innerHTML]="'video_question_info' | translate"
      ></p>
    </div>
    <div
      mat-dialog-content
      style="
        --mat-dialog-content-padding: 0;
        --mat-dialog-with-actions-content-padding: 0 var(--md-sys-size-2);
        --mdc-dialog-supporting-text-color: var(--md-sys-color-on-surface);
      "
    >
      <div class="grid">
        <exercise-task-module
          [componentBaseUrl]="questionBaseUrl"
          [config]="questions[0]"
          [onlyOneQuestion]="true"
          (questionAnswered)="questionAnswered($event)"
          [showQuestionNumber]="false"
          style="--exercise-task-card-background-color: transparent"
        ></exercise-task-module>
      </div>
    </div>
    @if (this.isQuestionCorrect === false || this.isQuestionCorrect === true) {
      <div mat-dialog-actions class="pt-2 flex-justify-content-center">
        @if (this.isQuestionCorrect === false) {
          <button mat-button (click)="close('repeatVideo')">
            <mat-icon>replay</mat-icon>
            {{ 'Replay_video' | translate }}
          </button>
        }
        @if (this.isQuestionCorrect === true) {
          <button mat-button (click)="close('nextVideo')">
            <mat-icon>arrow_forward</mat-icon>
            {{ 'Next_lesson' | translate }}
          </button>
        }
      </div>
    }
  </div>
}
